import { DatePickerPresentationProps } from "@insite/mobius/DatePicker";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { commonInputHeight, commonInputIcons } from "@solveindustrial/Utilities/styleguide/FormFields/formField";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const datePicker: RecursivePartial<{
    defaultProps?: DatePickerPresentationProps | undefined;
}> = {
    defaultProps: {
        cssOverrides: {
            datePicker: css`
                width: 100%;
                .react-datetime-picker__wrapper {
                    ${commonInputHeight};
                    ${mediaQueriesBP.minMD} {
                        height: 50px;
                        width: 100%;

                        display: flex;
                        justify-content: space-between;
                        padding: 0 1px;
                    }
                }

                .react-datetime-picker:not(:disabled),
                .react-datetime-picker:focus {
                    padding: 0 !important;

                    .react-datetime-picker__button {
                        padding: 0;
                        position: relative;
                    }

                    .react-datetime-picker__inputGroup {
                        ${mediaQueriesBP.maxMD} {
                            padding: 0 16px;
                        }

                        ${mediaQueriesBP.maxXLG} {
                            font-size: 14px;
                            padding: 0;
                        }
                    }
                }

                .react-calendar {
                    button {
                        &:enabled {
                            &:hover:not(:disabled),
                            &:focus:not(:disabled) {
                                background-color: ${getColor(colorStrings.commonSecondarySecond)};
                                color: ${getColor(colorStrings.commonGlobalGray01)};
                            }
                        }
                    }
                }

                .react-calendar .react-calendar__month-view__days__day,
                .react-calendar__tile--active:not(:disabled):not(
                        .react-calendar__month-view__days__day--neighboringMonth
                    ) {
                    min-height: 40px;
                    min-width: 35px;
                    width: 35px;
                    height: 40px;
                }

                .react-calendar__month-view__days__day {
                    font-size: 12px;
                }

                .react-calendar__navigation__label {
                    ${baseTheme.typography.p.css};
                    margin: 0;
                }

                .react-calendar__navigation {
                    align-items: center;

                    button {
                        min-height: 25px;
                    }
                }

                ${IconWrapper} {
                    color: ${getColor(colorStrings.primaryMain)};
                    ${commonInputIcons};

                    position: absolute;
                    inset-block-start: 50%;
                    transform: translateY(-50%);
                    inset-inline-end: 0;

                    ${mediaQueriesBP.minMD} {
                        width: 25px !important;
                        height: 35px;
                        min-height: 35px;
                        padding: 0;
                    }
                }
            `,
        },
        calendarIconProps: {
            css: css`
                width: 20px;
                height: 20px;
                ${mediaQueriesBP.minMD} {
                    width: 30px;
                    height: 30px;
                }
            `,
        },
    },
};
